enum ActionTypes {
    add,
    edit,
    sso_add,
    sso_validate,
    lock,
    unlock,
    freeze,
    unfreeze,
    reset_password,
    reset_mfa,
    close,
    reopen,
    delete,
    unmap,
    approve,
    decline,
    cancel,
    show_actions,
    more,
    hide,
    cancel_all,
    favorite,
    un_favorite,
    view
}

export const actionText = (type) => {
    switch (type) {
        case ActionTypes.delete:
            return 'Delete';
        case ActionTypes.add:
        case ActionTypes.sso_add:
        case ActionTypes.sso_validate:
            return 'Add';
        case ActionTypes.lock:
            return 'Lock';
        case ActionTypes.edit:
            return 'Edit';
        case ActionTypes.unlock:
            return 'Unlock';
        case ActionTypes.freeze:
            return 'Freeze';
        case ActionTypes.unfreeze:
            return 'Unfreeze';
        case ActionTypes.unmap:
            return 'Unmap';
        case ActionTypes.approve:
            return 'Approve';
        case ActionTypes.decline:
            return 'Decline';
        case ActionTypes.cancel:
            return 'Cancel';
        case ActionTypes.close:
            return 'Close';
        case ActionTypes.reopen:
            return 'Reopen';
        case ActionTypes.more:
            return 'More';
        case ActionTypes.show_actions:
            return 'Show Actions';
        case ActionTypes.hide:
            return 'Hide';
        case ActionTypes.cancel_all:
            return 'Cancel All';
        case ActionTypes.favorite:
            return 'Favorite'
        case ActionTypes.un_favorite:
            return 'Unfavorite';
        case ActionTypes.view:
            return 'View';
        default:
            return 'More';
    }
};

export default ActionTypes;
